import React, { memo, useCallback } from 'react';
import { Form } from 'react-final-form';
import { useParams } from 'react-router';
import arrayMutators from 'final-form-arrays';

import CreateMessageModalForm from './CreateMessageModalForm';
import validate from '../../../utils/validate';
import { createMessageYopValidation } from './validation';
import CommonModal from '../../../components/common-modal/CommonModal';

const CreateMessageModal = ({ isOpen, onClose, onCreateMessage }) => {
  const { id } = useParams();

  const createMessageInitialValues = {
    messages: [
      {
        message: '',
      },
    ],
  };

  const handleCreateMessage = useCallback(
    async (values) => {
      await onCreateMessage({ projectId: id, messages: values.messages });
      onClose();
    },
    [id, onClose, onCreateMessage],
  );

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <Form
        initialValues={createMessageInitialValues}
        onSubmit={handleCreateMessage}
        subscription={{ submitting: true, pristine: true }}
        mutators={{
          ...arrayMutators,
        }}
        validate={(values) => validate(values, createMessageYopValidation())}
        render={({ handleSubmit }) => <CreateMessageModalForm onSubmit={handleSubmit} onCancel={onClose} />}
      />
    </CommonModal>
  );
};

export default memo(CreateMessageModal);
